/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tags_Edit_TitleInputs */

const cs_clients_tags_edit_title = /** @type {(inputs: Clients_Tags_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit štítek`)
};

const en_clients_tags_edit_title = /** @type {(inputs: Clients_Tags_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit tag`)
};

/**
* | output |
* | --- |
* | "Edit tag" |
*
* @param {Clients_Tags_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tags_edit_title = /** @type {((inputs?: Clients_Tags_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tags_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tags_edit_title(inputs)
	return cs_clients_tags_edit_title(inputs)
});